import EnergieSparCheck from '@components/components/EnergieSparCheck/EnergieSparCheck';
import WarmWasserCheck from '@components/components/EnergieSparCheck/WarmWasserCheck/WarmWasserCheck';
import { HeizungsCheck } from '@components/components/HeizungsCheck';
import React from 'react';

const CmsEnergieSparCheck = ({ mainPosts, blogLink, type }) => {
  switch (type) {
    case 'isHeizung':
      return <HeizungsCheck />;
    case 'isWarmwasser': {
      const posts = mainPosts.filter(post => post.name === 'Wasser');
      return <WarmWasserCheck blogLink={blogLink} mainPosts={posts} />;
    }
    case 'isEnergie':
    default:
      return <EnergieSparCheck mainPosts={mainPosts} />;
  }
};
CmsEnergieSparCheck.size = 'full';

export default CmsEnergieSparCheck;
